import React from "react";

import adimg1 from '../images/adimg1.jpg';
import { Link } from 'react-router-dom';

const AdvertisementType1 = () => {

  return (
    <div className="avd-card desk">
      <div className="imgbox">
        <span className="price">₹ 55 L - 1.50 L</span>
        <span className="ad">Ad</span>
        <img src={adimg1} className="img-ad-01 mt-0" alt="..." />
      </div>
      <div className="card-body d-flex justify-content-between">
        <div className="d-grid">
          <span className="avd-title">Alora</span>
          <span className="avd-title-text">Malviya Nagar</span>
        </div>
        <div className="d-flex" style={{ alignItems: "end" }}>
          <div className="avd-icon d-flex">
            <Link to="/">
              <div>
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_3630_6618)">
                    <path
                      d="M4.95587 1.79672C5.51916 1.23344 6.28313 0.916992 7.07976 0.916992C8.73858 0.916992 10.0833 2.26175 10.0833 3.92059C10.0833 4.71719 9.76691 5.48117 9.20362 6.04445L8.02897 7.21908L7.21875 6.40885L8.3934 5.23422C8.74179 4.88583 8.9375 4.4133 8.9375 3.92059C8.9375 2.89457 8.10574 2.06283 7.07976 2.06283C6.58703 2.06283 6.1145 2.25855 5.7661 2.60695L4.59147 3.78158L3.78125 2.97135L4.95587 1.79672Z"
                      fill="#343434"
                    />
                    <path
                      d="M5.23373 8.3934L6.40836 7.21875L7.21859 8.02897L6.04396 9.20362C5.48068 9.76691 4.71671 10.0833 3.9201 10.0833C2.26126 10.0833 0.916504 8.73858 0.916504 7.07976C0.916504 6.28314 1.23295 5.51916 1.79623 4.95587L2.97086 3.78125L3.78109 4.59147L2.60646 5.7661C2.25806 6.1145 2.06234 6.58703 2.06234 7.07976C2.06234 8.10574 2.89409 8.9375 3.9201 8.9375C4.41281 8.9375 4.88534 8.74179 5.23373 8.3934Z"
                      fill="#343434"
                    />
                    <path
                      d="M4.18621 7.6237L7.6237 4.18621L6.81348 3.37598L3.37598 6.81348L4.18621 7.6237Z"
                      fill="#343434"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3630_6618">
                      <rect width="11" height="11" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div> 
            </Link>
            <Link to="/">
              <div>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.94629 1.49982C4.04981 1.49982 4.18978 1.49567 4.33105 1.52325L4.47168 1.56232L4.57715 1.61017C4.64482 1.64619 4.70764 1.69074 4.76465 1.742L4.8457 1.82501L4.93164 1.94318C5.00579 2.06645 5.0496 2.19943 5.08496 2.29669L5.60254 3.72247L5.69336 3.99005C5.71213 4.05673 5.72942 4.13475 5.7334 4.22247L5.73242 4.31329C5.72388 4.44403 5.68869 4.57101 5.62891 4.68634L5.56055 4.79767C5.488 4.90002 5.40252 4.971 5.32715 5.02423L5.08789 5.17462L4.87891 5.29865C5.31063 6.05608 5.94317 6.68845 6.7002 7.11993L6.8252 6.91193L6.97559 6.67267C7.0288 6.5973 7.09977 6.51183 7.20215 6.43927L7.31348 6.37091C7.4288 6.31113 7.55577 6.27594 7.68652 6.2674L7.77734 6.26642C7.86506 6.2704 7.9431 6.28769 8.00977 6.30646C8.09247 6.32975 8.18625 6.36416 8.27734 6.39728L9.70312 6.91486L9.93164 7.00372C9.9732 7.02247 10.0156 7.04346 10.0566 7.06818L10.1748 7.15411L10.2578 7.23517C10.309 7.29213 10.3536 7.35494 10.3896 7.42267L10.4375 7.52814L10.4766 7.66876C10.5042 7.81007 10.5 7.95007 10.5 8.05353V9.30548C10.5 9.4491 10.5089 9.65547 10.4404 9.85138L10.4062 9.93439C10.3461 10.0591 10.253 10.1747 10.1426 10.2635L10.0264 10.3426C9.92208 10.4026 9.81251 10.4341 9.70996 10.452L9.43555 10.4803C9.25492 10.4935 9.0724 10.4998 8.88867 10.4998C4.80807 10.4997 1.50012 7.19174 1.5 3.11115C1.5 2.92737 1.50632 2.74483 1.51953 2.56427L1.54785 2.28986C1.56574 2.18731 1.59725 2.07773 1.65723 1.97345L1.73633 1.85724C1.8251 1.74685 1.94069 1.65373 2.06543 1.59357L2.14844 1.55939C2.34432 1.49091 2.55065 1.49982 2.69434 1.49982H3.94629Z" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementType1;
